// shared-library/api/services/wechatAuthApi.js
/**
 * 微信认证相关API服务
 */
export default function(apiClient) {
  return {
    /**
     * 获取微信签名
     * @param {Object} data - 签名请求数据
     * @param {string} data.url - 当前页面URL
     * @param {string} data.type - 签名类型 (corp|agent)
     * @returns {Promise} - 返回签名信息的Promise
     */
    wechatSignature(data) {
      return apiClient.post('/auth/wechat/signature', data);
    },
    
    /**
     * 获取企业微信当前用户信息
     * @returns {Promise} - 返回当前用户信息的Promise
     */
    wechatFetchCurrentUser() {
      return apiClient.get('/auth/wechat/fetchCurrentUser');
    },
    
    /**
     * 获取企业微信用户列表
     * @returns {Promise} - 返回用户列表的Promise
     */
    wechatGetUsers() {
      return apiClient.get('/auth/wechat/users');
    },
    
    /**
     * 搜索企业微信用户
     * @param {string} keyword - 搜索关键词
     * @returns {Promise} - 返回搜索结果的Promise
     */
    wechatSearchUser(keyword) {
      return apiClient.get(`/auth/wechat/user/search?keyword=${encodeURIComponent(keyword)}`);
    },
  };
}